<div class="pr-medium-l pr-medium-r">
  <fcom-notification *ngIf="displayError$ | async; else availabilityForTier" [theme]="NotificationTheme.ALERT">
    {{ 'itineraryAndUpgradesModal.upgradeAvailability.error' | finLocalization }}
  </fcom-notification>

  <ng-template #availabilityForTier>
    <ng-container *ngIf="profileTier$ | async; else notLoggedIn">
      <ng-container *ngIf="eligible$ | async; else notEligible">
        <ng-container *ngIf="upgradeFlights$ | async as flights; else loading">
          <cms-unstyled-fragment
            *ngIf="seatsOrWaitlistAvailable$ | async"
            [contentUrl$]="contentUrl$"
          ></cms-unstyled-fragment>

          <fcom-notification *ngIf="hasPartnerOrDomestic$ | async" [class]="'mr-small-y'">
            <cms-unstyled-fragment [contentUrl$]="notEligibleContentUrl$"></cms-unstyled-fragment>
          </fcom-notification>

          <table class="fill font-body-1 mr-small-y" *ngIf="flights.length > 0">
            <caption class="is-vishidden">
              {{
                'itineraryAndUpgradesModal.upgradeAvailability.caption' | finLocalization
              }}
            </caption>
            <tr class="font-body-1 border-bottom">
              <th class="ps-large-r ps-xsmall-y align-left">
                {{ 'itineraryAndUpgradesModal.upgradeAvailability.flight' | finLocalization }}
              </th>
              <th *ngIf="showPremiumEconomy$ | async" class="align-left ps-xsmall-y">
                {{ 'itineraryAndUpgradesModal.upgradeAvailability.premiumEconomy' | finLocalization }}
              </th>
              <th class="align-left ps-xsmall-y">
                {{ 'itineraryAndUpgradesModal.upgradeAvailability.business' | finLocalization }}
              </th>
            </tr>
            <ng-container *ngFor="let flight of flights; last as isLast; index as index">
              <tr [class.border-bottom]="!isLast">
                <td class="ps-xsmall-y">
                  {{ flight.departure.locationCode }}-{{ flight.arrival.locationCode }}
                  <br />
                  {{ flight.flightNumber }}
                </td>
                <td *ngIf="showPremiumEconomy$ | async">
                  <ng-container
                    [ngTemplateOutlet]="cabinUpgradeCell"
                    [ngTemplateOutletContext]="{
                      flight,
                      seats: flight.premiumEconomySeats,
                      available: !flight.isShortHaul,
                      cabin: 'premium-economy',
                      index,
                    }"
                  ></ng-container>
                </td>
                <td>
                  <ng-container
                    [ngTemplateOutlet]="cabinUpgradeCell"
                    [ngTemplateOutletContext]="{
                      flight,
                      seats: flight.businessSeats,
                      available: true,
                      cabin: 'business',
                      index,
                    }"
                  ></ng-container>
                </td>
              </tr>
            </ng-container>
          </table>

          <div *ngIf="hasWaitlisted$ | async" class="mr-xsmall-b">
            <cms-unstyled-fragment [contentUrl$]="waitContentUrl$"></cms-unstyled-fragment>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>

<ng-template #notLoggedIn>
  <p class="pr-medium-b">
    {{ 'itineraryAndUpgradesModal.upgradeAvailability.requirements' | finLocalization }}
  </p>
  <fcom-button
    [size]="ButtonSize.LARGE"
    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
    [text]="'navigation.login' | finLocalization"
    (clickBtn)="login()"
  ></fcom-button>
</ng-template>

<ng-template #notEligible>
  <fcom-notification *ngIf="!tiersForUpgrade.includes(profileTier$ | async)">
    {{ 'itineraryAndUpgradesModal.upgradeAvailability.requirements' | finLocalization }}
  </fcom-notification>
  <fcom-notification *ngIf="isBusinessOnly$ | async">
    {{ 'itineraryAndUpgradesModal.upgradeAvailability.businessOnly' | finLocalization }}
  </fcom-notification>
</ng-template>

<ng-template #loading>
  <fcom-loader data-testid="upgrade-availability-loader"></fcom-loader>
</ng-template>

<ng-template
  #cabinUpgradeCell
  let-flight="flight"
  let-availableSeats="seats"
  let-available="available"
  let-cabin="cabin"
  let-index="index"
>
  <div
    [attr.data-testid]="'upgrade-info-segment-' + index + '-for-' + cabin"
    class="flex flex--align-start"
    [attr.data-seats-available]="availableSeats || 0"
  >
    <ng-container
      *ngIf="
        !available ||
          availableSeats === undefined ||
          flight.domestic ||
          (flight.tooCloseToWaitlist && availableSeats === 0) ||
          flight.tooCloseToDeparture ||
          !flight.finnairFlight ||
          flight.economyOnly;
        else seats
      "
    >
      <fcom-icon
        [dataTestId]="'upgrades-not-available-' + cabin"
        class="block error-900-text flex--nogrow"
        [name]="SvgLibraryIcon.CLOSE_DELETE_OUTLINE"
      >
      </fcom-icon>
      <span class="ms-xxsmall-l">
        {{
          'itineraryAndUpgradesModal.upgradeAvailability.' +
            (flight.domestic || !flight.finnairFlight
              ? 'notEligible'
              : flight.tooCloseToDeparture || (flight.tooCloseToWaitlist && availableSeats === 0)
                ? 'notPossible'
                : 'notAvailable') | finLocalization
        }}
      </span>
    </ng-container>
    <ng-template #seats>
      <fcom-icon
        [dataTestId]="'upgrades-available-' + cabin"
        *ngIf="availableSeats !== 0"
        class="flex--nogrow block success-900-text"
        [name]="SvgLibraryIcon.CHECKMARK"
      ></fcom-icon>
      <fcom-icon
        [dataTestId]="'upgrades-waitlisted-' + cabin"
        *ngIf="availableSeats === 0"
        class="flex--nogrow block"
        [name]="SvgLibraryIcon.TIME_ZONE"
      >
      </fcom-icon>
      <span class="ms-xxsmall-l">{{
        availableSeats === 0
          ? ('itineraryAndUpgradesModal.upgradeAvailability.waitlist' | finLocalization)
          : ((availableSeats === 1
              ? 'itineraryAndUpgradesModal.upgradeAvailability.seat'
              : 'itineraryAndUpgradesModal.upgradeAvailability.seats'
            ) | finLocalization: { seats: availableSeats > 5 ? '5+' : availableSeats })
      }}</span>
    </ng-template>
  </div>
</ng-template>
